import React, { useMemo } from "react";
import HelpLink from "../help/HelpLink";
import { useUserProfile } from "../../contexts/UserProfileContext";
import { computeWeeklyTargets, describeTargets } from "../../utils/weeklyTargets";

const SOURCE_NOTE = {
  programme: (days) => `Your programme sets ${days} days a week while it runs.`,
  history: (days) => `Auto: ${days} days a week, worked out from your last 8 weeks.`,
  default: (days) =>
    `Auto: ${days} days a week until there's enough history to work it out.`,
};

/**
 * What a goal and days a week add up to, as one plain line. Shown under the
 * fields that set them (Profile, the Activity sheet) so a change shows its
 * effect straight away.
 */
const WeeklyTargetSummary = ({ profile, programme, className }) => {
  const { sessions } = useUserProfile();
  const targets = useMemo(
    () =>
      computeWeeklyTargets({
        programme,
        userProfile: profile,
        trainingDates: (sessions || []).map((s) => s.started_at),
      }),
    [programme, profile, sessions],
  );
  const note = SOURCE_NOTE[targets.daysSource];

  return (
    <div className={className}>
      <p className="text-sm text-foreground">
        Each week: {describeTargets(targets.counts)}, and about{" "}
        {targets.setTarget} hard sets per muscle.
      </p>
      <p className="mt-0.5 text-xs text-muted-foreground">
        <HelpLink
          topic="weekly-targets"
          label="About weekly targets"
          className="mr-1 h-4 w-4 align-[-3px]"
        />
        {targets.familyLabel} goal.
        {note ? ` ${note(targets.days)}` : ""}
      </p>
    </div>
  );
};

export default WeeklyTargetSummary;
